export function BrandName({ className = '', style = {} }: { className?: string; style?: React.CSSProperties }) {
  return (
    <span className={`fw-bold ${className}`} style={{ color: '#d1d5db', letterSpacing: '-0.01em', ...style }}>
      Broom Wagon
    </span>
  );
}
